import React from 'react';

export const InfluencersPage = React.lazy(() => import('./InfluencersPage'));
